import { HTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



export interface ButtonCloseProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  theme?: 'grey';
  size?: 'small' | 'large';
}

export default function ButtonClose (props: ButtonCloseProps) {
  const { className, theme = '', ...rest } = props

  return (
    <button
      className={cn('reset-button', styles.root, className, {
        [styles[theme]]: theme,
      })}
      type="button"
      {...rest}
    >
      <img
        className={styles.root__img}
        src="/icons/cross.svg"
        alt=""
        loading="lazy"
        fetchPriority="low"
      />
    </button>
  )
}
